<template>
  <BaseSimpleLayout class="item-master-edit">
    <template #title>単品マスタ編集</template>
    <template v-if="loadingFlag" #main>
      <el-form
        ref="formRef"
        :model="editForm"
        :rules="rules"
        size="large"
        label-width="140px"
      >
        <el-form-item class="unit-master-item-edit-id" label="ID" prop="id">
          <el-input v-model="editForm.id" :disabled="true" />
        </el-form-item>
        <el-form-item
          class="unit-master-item-edit-name"
          label="品名"
          prop="name"
        >
          <el-input
            v-model="editForm.name"
            autocomplete="off"
            :disabled="isConfirm"
          />
        </el-form-item>
        <el-form-item
          class="unit-master-item-edit-model"
          label="型式"
          prop="model"
        >
          <el-input
            v-model="editForm.model"
            autocomplete="off"
            :disabled="isConfirm"
          />
        </el-form-item>
        <el-form-item
          class="unit-master-item-edit-part-code"
          label="品番"
          prop="partCode"
        >
          <el-input
            v-model="editForm.partCode"
            autocomplete="off"
            :disabled="isConfirm"
          />
        </el-form-item>
        <el-form-item
          class="unit-master-item-edit-category"
          label="カテゴリー"
          prop="categoryId"
        >
          <el-select
            v-model="editForm.categoryId"
            placeholder=""
            :disabled="isConfirm"
            @change="setCategory(false)"
          >
            <el-option
              v-for="category in categoryList"
              :key="category.id"
              :label="category.name"
              :value="category.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          class="unit-master-item-edit-sub-category"
          label="分類"
          prop="subCategoryId"
        >
          <el-select
            v-model="editForm.subCategoryId"
            placeholder=""
            :disabled="isConfirm || disableSubCategorySelect"
            @change="setSubCategory(false)"
          >
            <el-option
              v-for="subCategory in subCategoryList"
              :key="subCategory.id"
              :label="`${String(subCategory.id).padStart(2, '0')}: ${
                subCategory.name
              }`"
              :value="subCategory.id"
            />
          </el-select>
          <span>※ カテゴリー選択後選択可</span>
        </el-form-item>
        <el-form-item
          class="unit-master-item-edit-minor-sub-category"
          label="小分類"
          prop="subSubCategoryId"
        >
          <el-select
            v-model="editForm.subSubCategoryId"
            placeholder=""
            :disabled="isConfirm || disableSubSubCategorySelect"
          >
            <el-option
              v-for="subSubCategory in subSubCategoryList"
              :key="subSubCategory.id"
              :label="`${String(subSubCategory.id).padStart(2, '0')}: ${
                subSubCategory.name
              }`"
              :value="subSubCategory.id"
            />
          </el-select>
          <span>※ 分類選択後選択可</span>
        </el-form-item>
        <el-form-item
          class="unit-master-item-edit-base-cost"
          label="基準原価 (円)"
          prop="baseCost"
        >
          <el-input-number
            v-model="editForm.baseCost"
            :precision="2"
            :min="0"
            :controls="false"
            :disabled="isConfirm"
          />
        </el-form-item>
        <el-form-item
          class="unit-master-item-edit-case-cost"
          label="ケース単価 (円)"
          prop="caseCost"
        >
          <el-input-number
            v-model="editForm.caseCost"
            :precision="2"
            :min="0"
            :controls="false"
            :disabled="isConfirm"
          />
        </el-form-item>
        <el-form-item
          class="unit-master-item-edit-lot-qty"
          label="入数"
          prop="lotQty"
        >
          <el-input-number
            v-model="editForm.lotQty"
            :precision="0"
            :min="0"
            :controls="false"
            :disabled="isConfirm"
          />
        </el-form-item>
        <el-form-item
          class="unit-master-item-edit-lead-time-day"
          label="リードタイム (日)"
          prop="leadTimeDay"
        >
          <el-input-number
            v-model="editForm.leadTimeDay"
            :precision="0"
            :min="0"
            :controls="false"
            :disabled="isConfirm"
          />
        </el-form-item>
        <el-form-item
          class="unit-master-item-edit-supplier"
          label="仕入先"
          prop="supplierId"
        >
          <el-select
            v-model="editForm.supplierId"
            clearable
            placeholder=""
            :disabled="isConfirm"
          >
            <el-option
              v-for="supplier in supplierList"
              :key="supplier.id"
              :label="`${String(supplier.id).padStart(2, '0')}: ${
                supplier.name
              }`"
              :value="supplier.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          class="unit-master-item-edit-note"
          label="備考"
          prop="note"
        >
          <el-input
            v-model="editForm.note"
            type="textarea"
            :rows="4"
            autocomplete="off"
            :disabled="isConfirm"
          />
        </el-form-item>
        <el-form-item
          class="unit-master-item-edit-is-stock"
          label="在庫管理"
          prop="isStock"
        >
          <el-radio-group v-model="editForm.isStock" :disabled="isConfirm">
            <el-radio :label="true">管理する</el-radio>
            <el-radio :label="false">管理しない</el-radio>
          </el-radio-group>
        </el-form-item>
        <div v-if="isConfirm" class="button-area">
          <el-button type="info" size="large" @click="isConfirm = false">
            キャンセル
          </el-button>
          <el-button type="primary" size="large" @click="update()">
            更新
          </el-button>
        </div>
        <div v-else class="button-area">
          <el-button
            class="unit-master-item-edit-button-detail"
            type="info"
            size="large"
            @click="router.push(`/master/item/${editForm.id}`)"
          >
            戻る
          </el-button>
          <el-button
            class="unit-master-item-edit-button-confirm"
            type="primary"
            size="large"
            @click="changeConfirm(formRef)"
          >
            確認
          </el-button>
        </div>
      </el-form>
    </template>
  </BaseSimpleLayout>
</template>

<script setup lang="ts">
  import { ref } from 'vue';
  import { useStore } from 'vuex';
  import router from '@/router';
  import BaseSimpleLayout from '@/components/BaseSimpleLayout.vue';
  import type { FormInstance, FormRules } from 'element-plus';
  import { ItemPutDataState } from '@/types/master/item';
  import { CategoryListState } from '@/types/category';
  import { SubCategoriesDataState } from '@/types/master/subCategory';
  import { SubSubCategoriesDataState } from '@/types/master/subSubCategory';
  import { SupplierDataState } from '@/types/master/supplier';

  const store = useStore();
  const formRef = ref<FormInstance>();
  const editForm = ref<ItemPutDataState>({
    id: 0,
    name: '',
    model: '',
    partCode: '',
    categoryId: null,
    baseCost: 0,
    caseCost: 0,
    lotQty: 1,
    leadTimeDay: 0,
    supplierId: null,
    subCategoryId: null,
    subSubCategoryId: null,
    isStock: true,
    note: ''
  });
  const rules = ref<FormRules>({
    name: [{ required: true, message: '品名は必須です。' }],
    categoryId: [{ required: true, message: 'カテゴリーは必須です。' }],
    partCode: [{ required: true, message: '品番は必須です。' }],
    baseCost: [{ required: true, message: '基準原価は必須です。' }],
    caseCost: [{ required: true, message: 'ケース単価は必須です。' }],
    lotQty: [{ required: true, message: '入数は必須です。' }],
    leadTimeDay: [{ required: true, message: 'リードタイムは必須です。' }]
  });
  const categoryList = ref<CategoryListState[]>([]);
  const subCategoryList = ref<SubCategoriesDataState[]>([]);
  const subSubCategoryList = ref<SubSubCategoriesDataState[]>([]);
  const supplierList = ref<SupplierDataState[]>([]);
  const loadingFlag = ref(false);
  const disableSubCategorySelect = ref(true);
  const disableSubSubCategorySelect = ref(true);
  const isConfirm = ref(false);

  const initialize = async () => {
    if (!store.state.itemMaster.putData) {
      router.push('/master/item');
    } else {
      editForm.value = store.state.itemMaster.putData;
    }
    categoryList.value = store.state.categoryMaster.listData;
    subCategoryList.value = store.state.subCategoriesMaster.listData;
    subSubCategoryList.value = store.state.subSubCategoriesMaster.listData;
    supplierList.value = store.state.suppliersMaster.listData;
    loadingFlag.value = true;
    if (editForm.value.categoryId) {
      await setCategory(true);
    }
    if (editForm.value.subCategoryId) {
      await setSubCategory(true);
    }
  };

  const setCategory = async (initial = false) => {
    subCategoryList.value = store.state.subCategoriesMaster.listData.filter(
      (subCategory: SubCategoriesDataState) =>
        subCategory.categoryId === editForm.value.categoryId
    );
    disableSubCategorySelect.value = false;
    if (!initial) {
      editForm.value.subCategoryId = null;
      editForm.value.subSubCategoryId = null;
    }
  };

  const setSubCategory = async (initial = false) => {
    await store.dispatch('subSubCategoriesMaster/fetch');
    subSubCategoryList.value =
      store.state.subSubCategoriesMaster.listData.filter(
        (subSubCategory: SubSubCategoriesDataState) =>
          subSubCategory.subCategoryId === editForm.value.subCategoryId
      );
    disableSubSubCategorySelect.value = false;
    if (!initial) {
      editForm.value.subSubCategoryId = null;
    }
  };

  const changeConfirm = async (formEl: FormInstance | undefined) => {
    if (!formEl) return;
    await formEl.validate((valid) => {
      if (!valid) {
        return false;
      }
      isConfirm.value = true;
    });
  };

  const update = async () => {
    store.dispatch('itemMaster/put', editForm.value);
  };
  initialize();
</script>
<style lang="scss">
  .item-master-edit {
    form {
      width: 650px;
      display: inline-block;
    }
    .el-input-number {
      .el-input {
        float: left;
        width: 130px;
      }
      .el-input__inner {
        text-align: left;
      }
    }
    .el-select {
      width: 330px;
      float: left;
    }
    .el-form-item {
      font-weight: 600 !important;

      span:not(.el-radio__inner):not(.el-radio__label) {
        color: #606266;
        font-weight: 100;
      }
    }
    .el-button {
      font-weight: 600;
    }
    .button-area {
      margin: 0px 0px 10px 0px;
    }
  }
</style>
